const Spinner = ({ size = 'lg', color = 'white', className }, props) => <span className={`spinner-border spinner-border-${size} text-${color} ${className}`} {...props}></span>

export default Spinner